import Swiper from "swiper";

class ModuleSliderValeurs {
  constructor() {
    this.trigger = document.querySelector(
      '[data-trigger="module-slider-valeurs"]'
    );
    this._init();
  }

  _init() {
    this.swiper = new Swiper(this.trigger, {
      breakpoints: {
        640: {
          slidesPerView: 1
        }
      },
      slidesPerView: "auto",
      spaceBetween: 60,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  }
}

export const moduleSliderValeurs = new ModuleSliderValeurs();
